<script>
export default {
  data() {
    this.fetchGroups = _.debounce(this.fetchGroups, 800)
    return {
      data: [],
      value: [],
      fetching: false
    }
  },
  methods: {
    fetchGroups(value) {
      this.data = []
      this.fetching = true
      this.$http.get(this.routeUri('hyperion.product-group'), {
        params: {q: value}
      })
        .then((response) => this.data = response.data.data)
        .finally(() => this.fetching = false)
    },
    handleChange(value) {
      let map = _.map(value, 'key')
      this.$emit('change', _.filter(this.data, (o) => map.includes(o.id)))

      Object.assign(this, {
        value,
        data: [],
        fetching: false
      })
    }
  }
}
</script>
<template>
  <a-select
    labelInValue
    mode="multiple"
    :value="value"
    placeholder="Select Product Group"
    style="width: 100%"
    :filterOption="false"
    @search="fetchGroups"
    @change="handleChange"
    @focus="fetchGroups"
    :notFoundContent="fetching ? undefined : null "
    :loading="fetching">
    <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
    <a-select-option v-for="d in data" :key="d.id" :value="d.id">{{ d.name }}</a-select-option>
  </a-select>
</template>
